<template>
  <div class="c-footer">
    <div class="container-auto">
      <div class="footer-top flex justify-center">
        <div class="footer-address flex items-center">
          <img src="@/assets/img/footer/icon-1.svg" alt="">
          地址：宁波市鄞州区宁穿路2001号市行政中心2号楼
        </div>
        <div class=" flex items-center">
          <img src="@/assets/img/footer/icon-2.svg" alt="">
          网站联系电话：0574-89292467
        </div>
      </div>
      <div class="footer-bottom">
        版权所有：中共宁波市委金融委员会办公室（宁波市地方金融管理局） 浙ICP备 13020368号-2
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CFooter"
}
</script>
<style scoped lang="scss">
.c-footer {
  height: 153px;
  width: 100%;
  background: url("~@/assets/img/footer/bg.png") no-repeat center center;
  background-size: cover;

  .footer-top {
    padding: 30px;
    font-size: 14px;
    line-height: 30px;
    color: #FFFFFF;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    .footer-address {
      margin-right: 80px;
    }

    img {
      margin-right: 5px;
    }
  }
  .footer-bottom{
    padding-top: 16px;
    font-size: 12px;
    line-height: 30px;
    text-align: center;
    color: #FFFFFF;
    opacity: 0.6;
  }
}
</style>
